<script>
import NavBar from '@components/nav-bar.vue'
import SignOut from '@components/sign-out.vue'

export default {
  components: { NavBar, SignOut },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    onCollapse(collapsed, type) {},
    onBreakpoint(broken) {},
  },
}
</script>

<template>
  <a-layout id="components-layout-demo-responsive">
    <a-layout-sider
      breakpoint="lg"
      collapsed-width="0"
      :collapsible="true"
      @collapse="onCollapse"
      @breakpoint="onBreakpoint"
    >
      <div class="logo" />
      <NavBar v-if="$auth.isAuthenticated && $auth.user.profile" />
      <div class="sign-out--container">
        <SignOut />
      </div>
    </a-layout-sider>
    <a-layout>
      <a-layout-content :style="{ margin: '24px 16px 0' }">
        <slot />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<style lang="scss" module>
@import '@design';

.container {
  min-width: $size-content-width-min;
  max-width: $size-content-width-max;
  margin: 0 auto;
}
</style>
